export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-a72f6ee31222332cb98232d5152f7807.woff";